import { createHttpLinkServer} from "./core/link";
import {HasuraHeaders, Options} from "./types";
import { getMainDefinition } from "@apollo/client/utilities";
import {ApolloClient, InMemoryCache, split, createHttpLink, from, FetchResult, Observable} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { RetryLink } from "@apollo/client/link/retry";
import { createClient as createWsClient, CloseCode} from "graphql-ws";
import { offsetLimitPagination } from "@apollo/client/utilities";
import atob from "./atob";

import { GraphQLError } from "graphql";
let apolloClient: ApolloClient<any>;
let currentOptions: Options = {};

export function parseToken(token:string)   {
	try {
		if (token) {
			return JSON.parse(atob(token.split(".")[1]));

		}
	}
	catch (e) {
		console.error(e);
	}
}

const retryLink = new RetryLink({
	delay: {
		initial: 300,
		max: Infinity,
		jitter: true
	},
	attempts: {
		max: Infinity,
		retryIf: (error, _operation) => Boolean(error)
	}
});
// export parseToken
let wsClient;
const currentToken = null;
const refreshQueue = [];

const errorLink = onError(
	({ graphQLErrors, networkError, operation, forward }) => {

		if (graphQLErrors) {
			for (const err of graphQLErrors) {
				console.log(err);
				if (err.extensions.code === "postgres-error") {
					// Handle invalid JWT
					return forward(operation);
				}
				else if (err.extensions.code === "invalid-jwt") {
					// ignore 401 error for a refresh request
					// if (operation.operationName === 'refreshToken') return;
					console.log(operation.operationName);

					const observable = new Observable<FetchResult<Record<string, any>>>(
						// eslint-disable-next-line no-loop-func
						(observer) => {
							// used an annonymous function for using an async function

							(async() => {
								try {
									// const {refreshToken} = <Options>currentOptions;
									// console.log("CALLING REFRESH TOKEN");
									const accessToken = currentOptions.token;

									// console.log(accessToken);
									if (!accessToken) {
										throw new GraphQLError("Empty AccessToken");
									}

									// Retry the failed request
									const subscriber = {
										next: observer.next.bind(observer),
										error: observer.error.bind(observer),
										complete: observer.complete.bind(observer)
									};

									forward(operation).subscribe(subscriber);
								}
								catch (err) {
									observer.error(err);
								}
							})();
						}
					);

					return observable;
				}
			}
		}

		if (networkError) console.log(`[Network error]: ${networkError}`);
	}
);
const createWSLink = (url: string) => {
	console.info(`creating websocket link to ${url}`);
	let tokenExpiryTimeout:any = -1;
	wsClient = createWsClient({
		url: `${url.replace("http", "ws")}`,
		retryAttempts: Infinity,
		shouldRetry: (errOrCloseEvent:any) =>
		//		console.log(errOrCloseEvent);
			 true,
		connectionParams: async() => {
			// console.info("connection params");
			const {role} = <Options>currentOptions;
			const data = currentOptions.token as any;

			const headers = <HasuraHeaders>{
				"x-hasura-role": role,
				"Sec-WebSocket-Protocol": "graphql-transport-ws"
			};

			if ( data) {
				headers.authorization = `Bearer ${ data}`;
			}
			return {headers};
		},
		on: {
			connected: async(socket: any) => {
				// console.log("Connected again");

				// clear timeout on every connect for debouncing the expiry
				clearTimeout(tokenExpiryTimeout);
				const {onReconnect} = <Options>currentOptions;
				const data = currentOptions.token as any;

				onReconnect && onReconnect();
				// set a token expiry timeout for closing the socket
				// with an `4403: Forbidden` close event indicating
				// that the token expired. the `closed` event listner below
				// will set the token refresh flag to true
				// @ts-ignore

				const tokenParsed = parseToken(data);

				const expires = (tokenParsed.exp * 1000) - Date.now();
				console.debug(`Token expires in ${expires}`);
				tokenExpiryTimeout = setTimeout(() => {
					socket.close(CloseCode.Forbidden, "Forbidden");
				}, expires);
			},
			closed(event) {
				// if closed with the `4403: Forbidden` close event
				// the client or the server is communicating that the token
				// is no longer valid and should be therefore refreshed
				// console.log("CLOSED");
				// console.log(JSON.stringify(event));
			}
		}
	});
	return new GraphQLWsLink(wsClient);
};

const authLink = setContext(async(_, { headers }) => {
	const data = currentOptions.token as any;
	return ({
		headers: {
			"Authorization": `Bearer ${data}`,
			"x-hasura-role": currentOptions.role,
			...headers
		}
	});
});



const createApolloClient = (url:string) => {
	if (apolloClient) return apolloClient;
	const httpLink = createHttpLink({uri: url});
	const ssrMode = typeof window === "undefined";
	let link;
	if (ssrMode) {
		link = createHttpLinkServer(url); // executed on server
	}
	else {
		const wsLink = split(
			({ query }) => {
				const definition = getMainDefinition(query);
				return (
					definition.kind === "OperationDefinition" &&
                    definition.operation === "subscription"
				);
			},
			createWSLink(url)
		);

		link = from([retryLink, errorLink, authLink, wsLink, httpLink]);
	}
	console.log("INIT APOLLO");
	// eslint-disable-next-line no-return-assign
	apolloClient = new ApolloClient({
		ssrMode,
		link,
		connectToDevTools: true,
		cache: new InMemoryCache({
			typePolicies: {
				queueItem: {
					fields: {
						isOptimistic: {
							read(current) {
								//console.log('current', current);
								return Boolean(current);
							}
						}
					}
				},
				Query: {
					fields: {
						messagingMessages: offsetLimitPagination(["where"]),
						queueItems: offsetLimitPagination(["$organizationUserId", "where", ["status", ["_in"]]])
					}
				}

			/*	MessagingMessage: {
					fields: {
						messageEmojis: {
							merge: (existing = [], incoming = []) => {
								const ret = [...existing];

								for (let i = 0; i < incoming.length; i++ ) {
									let found = false;
									for (let j = 0; j < existing.length; j++) {
										if (incoming[i].id === existing[j].id) {
											found = true;
										}
									}
									if (!found) {
										ret.push(incoming[i]);
									}
								}
								return incoming;
							}
						}
					}
				}*/
			}
		})
	});
	return apolloClient;
};


export const createClient = (url: string, options:Options) => {

	currentOptions = options;
	if (apolloClient) return apolloClient;
	return createApolloClient(url);
};
